/**
 * Filters and keeps only the specified parameters from the provided URLSearchParams.
 *
 * @param {URLSearchParams} search - The original URLSearchParams object to filter.
 * @param {string[]} paramsToKeep - The list of parameter names to retain in the resulting URLSearchParams.
 * @returns {URLSearchParams} A new URLSearchParams object containing only the specified parameters.
 */
export const keepSpecificParams = (
  search: URLSearchParams,
  paramsToKeep: string[]
): URLSearchParams => {
  const currentSearchParams = new URLSearchParams(search);
  const newSearchParams = new URLSearchParams();

  paramsToKeep.forEach((param) => {
    const values = currentSearchParams.getAll(param);
    values.forEach((value) => {
      newSearchParams.append(param, value);
    });
  });

  return newSearchParams;
};
